import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path fill="transparent" d="M0 0h32v32H0z" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.95 16.95a3.37 3.37 0 1 0 0-6.74 3.37 3.37 0 0 0 0 6.74M10.67 20.62c.8-2.14 2.86-3.67 5.28-3.67 2.33 0 4.33 1.42 5.19 3.44"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m10.67 7.02 2.68-1.15V2.54h5.19v3.22l2.83 1.26 2.36-2.24 3.58 3.6-2.36 2.29 1.29 2.75h3.25v5.16h-3.07l-1.36 2.93 2.25 2.22-3.54 3.62-2.19-2.26-3 1.22.03 3.15h-5.22l-.04-3.01-2.68-1.32-2.33 2.18-3.47-3.54 2.22-2.19-1.33-2.8H2.51v-5.2h3.22l1.25-2.88-2.26-2.22 3.62-3.5z"
    />
  </svg>
);
const SvgIconRoleManagement = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconRoleManagement);
export default Memo;
